import { useRouteNamespaces } from '@aikoa/i18n/react'
import { Slot } from 'expo-router'

export default function AdminLayout() {
  useRouteNamespaces('(authenticated)/admin')
  return <Slot />
}
